import { styled } from '@mui/material/styles';

export const DrawerContent = styled('div')(({ theme }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  padding: theme.spacing(4),
}));

export const CloseBtnPosition = styled('div')(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(4),
  top: theme.spacing(4),
  zIndex: 1000,
}));
